var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{staticClass:"kv-tab",class:{ 'kv-tab--active': _vm.isActive },attrs:{"type":"button"},on:{"click":_vm.selectTabHandler}},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }